import { KnmPmActionsEnum } from '../enums/KnmPmActionsEnum';
import { IKnmPmState } from '../interfaces/IKnmPmState';
import { KnmPmAction } from '../types/KnmPmAction';

const initialState: IKnmPmState = {
  wasFirstInit: false,
  initialFormValues: {
    knoOrganizationPm: undefined,
    supervisionTypePm: undefined,
    pmType: undefined,
    startDate: undefined,
    stopDate: undefined,
    location: undefined,
    noteWarning: undefined,
    contentWarningAttachments: undefined,
    objectionWarningAttachments: undefined,
    exampleWarningAttachments: undefined,
    reasonsPm: undefined,
    inn: undefined,
    ogrn: undefined,
    checkSubjectResult: null,
    okveds: undefined,
    organizationName: undefined,
    organizationAutocomplete: undefined,
    objectsPm: undefined,
    isHasCollaboratingOrganization: undefined,
    collaboratingOrganizationsErknm: undefined,
    isHasNotification: undefined,
    dateOfNotification: undefined,
    inspectorsErknm: undefined,
    resultOfInspection: undefined,
    isRejectSubject: undefined,
    dateRejectSubject: undefined,
    requirementsNpa: undefined,
    subjectNotifications: undefined,
    pmReject: undefined,
    pmResultDecisions: undefined,
    withoutIssue: undefined,
    subjectTypePm: undefined,
  },
  planKnmMessageModalState: {
    visible: false,
  },
};

export function knmPmReducer(state: IKnmPmState = initialState, action: KnmPmAction): IKnmPmState {
  switch (action.type) {
    case KnmPmActionsEnum.KNM_PM_SET_INITIAL_FORM_VALUES: {
      const { initialFormValues } = action.payload;

      return {
        ...state,
        initialFormValues: {
          ...state.initialFormValues,
          ...initialFormValues,
        },
      };
    }
    case KnmPmActionsEnum.KNM_PM_RESET_INITIAL_FORM_VALUES: {
      return {
        ...state,
        initialFormValues: initialState.initialFormValues,
      };
    }
    case KnmPmActionsEnum.KNM_PM_SET_PLAN_KNM_SELECT_OPTIONS: {
      const { selectOptions } = action.payload;

      return {
        ...state,
        planKnmSelectOptions: selectOptions,
      };
    }
    case KnmPmActionsEnum.KNM_PM_OPEN_PLAN_KNM_MESSAGE_MODAL: {
      const { id, type } = action.payload;

      return {
        ...state,
        planKnmMessageModalState: {
          visible: true,
          type,
          id,
        },
      };
    }
    case KnmPmActionsEnum.KNM_PM_CLOSE_PLAN_KNM_MESSAGE_MODAL: {
      return {
        ...state,
        planKnmMessageModalState: {
          visible: false,
        },
      };
    }
    case KnmPmActionsEnum.KNM_PM_SET_WAS_FIRST_INIT: {
      const { wasFirstInit } = action.payload;

      return {
        ...state,
        wasFirstInit,
      };
    }
    case KnmPmActionsEnum.KNM_PM_SET_STATUS_HINT_TEXT: {
      return {
        ...state,
        statusHintText: action.payload.value,
      };
    }
    case KnmPmActionsEnum.KNM_PM_SET_STATUS_HINT_FIELDS: {
      return {
        ...state,
        statusHintFields: action.payload.fields,
      };
    }
    default:
      return state;
  }
}
